import React, { useState } from "react";
import {Modal} from 'carbon-components-react';
import {confirmable, createConfirmation} from 'react-confirm';

const Confirmation = ({show, confirmation, proceed, title, backButton, buttonText, ...options}) => {
    return(
        <Modal size="xs" open={show} modalHeading={title || "Confirm?"} closeButtonLabel={"Cancel"} onRequestClose={() => proceed(false)} onRequestSubmit={() => proceed(true)} preventCloseOnClickOutside primaryButtonText={buttonText || "Confirm"} secondaryButtonText={backButton || "Cancel"} onSecondarySubmit={() => proceed(false)}>
            <div className="mb-6">
                {confirmation}
            </div>
        </Modal>
    )
}

const confirmLow = createConfirmation(confirmable(Confirmation));

const confirm = (message, options = {}) => {
    return confirmLow(Object.assign({confirmation: message}, options));
};

export default confirm;